"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDropdownItem = void 0;
var clsx_1 = __importDefault(require("clsx"));
var path_parser_1 = require("path-parser");
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var react_router_dom_1 = require("react-router-dom");
var AcPopover_1 = require("../display/AcPopover");
var AcDropdownItem_module_scss_1 = __importDefault(require("./AcDropdownItem.module.scss"));
var ConditionalWrap = function (_a) {
    var condition = _a.condition, wrap = _a.wrap, children = _a.children;
    return (condition ? wrap(children) : react_1.default.createElement(react_1.default.Fragment, null, children));
};
var AcDropdownItem = function (_a) {
    var _b, _c, _d;
    var _e, _f;
    var eventKey = _a.eventKey, data = _a.data, functionContext = _a.functionContext, action = _a.action, size = _a.size, onMouseDown = _a.onMouseDown, onClickBeforeAction = _a.onClickBeforeAction;
    var history = react_router_dom_1.useHistory();
    var onClickItem = function (e) {
        e.preventDefault();
        e.stopPropagation();
        // if (!data) {
        // console.error('DATA NOT FOUND in AcDropdownItem');
        // return;
        // }
        onClickBeforeAction === null || onClickBeforeAction === void 0 ? void 0 : onClickBeforeAction();
        if (action.onClick) {
            action.onClick(data || {}, functionContext || {});
        }
        else if (action.path) {
            var pathParser = new path_parser_1.Path(action.path);
            var path = pathParser.build(data);
            history.push(path);
        }
    };
    var disabled;
    if (typeof action.disabled === 'function') {
        disabled = action.disabled(data || {}, functionContext || {});
    }
    else {
        disabled = action.disabled;
    }
    var item;
    if (typeof action.title === 'function') {
        item = action.title(data || {}, functionContext || {});
    }
    else {
        item = (react_1.default.createElement(react_1.default.Fragment, null,
            typeof (action === null || action === void 0 ? void 0 : action.icon) === 'string' ? (react_1.default.createElement("i", { className: action.icon + " " + (size === 'xl' || size === 'lg' ? 'fs-maximum' : 'fs-medium') + " fa-fw mr-2" })) : (action === null || action === void 0 ? void 0 : action.icon),
            react_1.default.createElement("span", { className: size === 'xl' || size === 'lg'
                    ? 'font-weight-bold fs-default text-primary'
                    : 'font-weight-light fs-minimum' }, action.title ? action.title : action.name),
            (action === null || action === void 0 ? void 0 : action.trailing) != null && react_1.default.createElement("span", { className: "ml-auto" }, action.trailing)));
    }
    var showHover;
    if (typeof action.showHover === 'function') {
        showHover = action.showHover(data || {}, functionContext || {});
    }
    else {
        showHover = action.showHover;
    }
    var hoverText;
    if (typeof ((_e = action.hoverOptions) === null || _e === void 0 ? void 0 : _e.text) === 'function') {
        hoverText = action.hoverOptions.text(data || {}, functionContext || {});
    }
    else {
        hoverText = (_f = action.hoverOptions) === null || _f === void 0 ? void 0 : _f.text;
    }
    return (react_1.default.createElement(ConditionalWrap, { condition: showHover, wrap: function (children) {
            var _a;
            return (react_1.default.createElement(AcPopover_1.AcPopover, { placement: (_a = action.hoverOptions) === null || _a === void 0 ? void 0 : _a.placement, text: hoverText }, children));
        } },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { eventKey: eventKey, onMouseDown: onMouseDown, onClick: onClickItem, disabled: disabled, className: clsx_1.default('d-flex align-items-center', action.actionClassName, (_b = {}, _b[AcDropdownItem_module_scss_1.default.dropdownItemSm] = size === 'sm', _b), (_c = {}, _c[AcDropdownItem_module_scss_1.default.dropdownItemLg] = size === 'lg', _c), (_d = {}, _d[AcDropdownItem_module_scss_1.default.dropdownItemXl] = size === 'xl', _d)), style: {
                opacity: disabled ? 0.6 : undefined,
                minWidth: size === 'xl' ? '270px' : undefined,
            } }, item)));
};
exports.AcDropdownItem = AcDropdownItem;
exports.AcDropdownItem.displayName = 'AcDropdownItem';
//# sourceMappingURL=AcDropdownItem.js.map